import { render, staticRenderFns } from "./BillDetails.vue?vue&type=template&id=5fdfb073&scoped=true"
import script from "./BillDetails.vue?vue&type=script&lang=js"
export * from "./BillDetails.vue?vue&type=script&lang=js"
import style0 from "./BillDetails.vue?vue&type=style&index=0&id=5fdfb073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdfb073",
  null
  
)

export default component.exports